import { Menu } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import CopyTextButton from 'components/copy-text-button'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'
import useStyles, {
  StyledMenuItem,
  StyledCheckIcon,
} from './integrations.styles'

export const SubscribeMapper = {
  default: 'Select an option to subscribe',
  google: 'Subscribed to Google Calendar',
  outlook: 'Subscribed to Outlook.com',
  'your-calendar': 'Subscribed to Your Calendar App',
  'copy-calendar-url': 'Copied Calendar URL',
}

export default function SubscribeAction({
  calUrl,
  selectedCalendar,
  setSelectedCalendar,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const styles = useStyles()

  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const webcalUrl = new URL(calUrl)
  webcalUrl.protocol = 'webcal'

  const SubscribeMenu = () => (
    <Menu
      id="simple-menu"
      keepMounted
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <StyledMenuItem>
        <Button
          href={`https://www.google.com/calendar/render?cid=${encodeURIComponent(
            webcalUrl,
          )}`}
          variant="text"
          target="_blank"
          className={styles.menuItem}
          onClick={() => setSelectedCalendar('google')}
        >
          With Google Calendar
        </Button>
        {selectedCalendar === 'google' && <StyledCheckIcon />}
      </StyledMenuItem>
      <StyledMenuItem>
        <Button
          href={`https://outlook.live.com/owa?path=/calendar/action/compose&rru=addsubscription&url=${encodeURIComponent(
            webcalUrl,
          )}&name=PGA%20Coach`}
          variant="text"
          target="_blank"
          className={styles.menuItem}
          onClick={() => setSelectedCalendar('outlook')}
        >
          With Outlook.com
        </Button>
        {selectedCalendar === 'outlook' && <StyledCheckIcon />}
      </StyledMenuItem>
      <StyledMenuItem>
        <Button
          href={webcalUrl}
          variant="text"
          target="_blank"
          className={styles.menuItem}
          onClick={() => setSelectedCalendar('your-calendar')}
        >
          With Your Calendar App
        </Button>
        {selectedCalendar === 'your-calendar' && <StyledCheckIcon />}
      </StyledMenuItem>
      <StyledMenuItem>
        <CopyTextButton
          value={calUrl}
          component={Button}
          notificationtext="Copied calendar url to clipboard"
          className={styles.menuItem}
          onClick={() => setSelectedCalendar('copy-calendar-url')}
        >
          Copy Calendar URL
        </CopyTextButton>
        {selectedCalendar === 'copy-calendar-url' && <StyledCheckIcon />}
      </StyledMenuItem>
    </Menu>
  )

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={styles.action}
      >
        <MoreVertIcon fontSize="medium" />
      </Button>
      <SubscribeMenu />
    </>
  )
}
